/* eslint-disable indent, @typescript-eslint/indent, react/jsx-indent, react/jsx-indent-props */
import React from 'react';
import { VideoPlayer, VideoQuality, Stream } from '@zoom/videosdk';
import s from './s.module.less';
import { ZoomParticipant } from '../../type';
import Logo from 'assets/logo/iconLogo.png';

type Props = {
    mediaStreamRef?: React.RefObject<typeof Stream>;
    zoomParticipant?: ZoomParticipant;
    width?: number;
    height?: number;
};

// Zoom SDK 的 Part
const ZoomPIPView = (props: Props) => {
    const { mediaStreamRef, zoomParticipant, width, height } = props;
    const videoRef = React.useRef<VideoPlayer | null>(null);
    const currentAttachedUserId = React.useRef<number | null>(null);
    const [isVideoOn, setIsVideoOn] = React.useState<boolean>(false);

    React.useEffect(() => {
        // 保存 ref 的当前值，以便在 cleanup 中使用
        const mediaStream = mediaStreamRef?.current;
        const videoElement = videoRef.current;
        const userId = zoomParticipant?.userId;
        // 使用传入的bVideoOn prop，如果没有则使用zoomParticipant中的值
        const videoOn = zoomParticipant?.bVideoOn;
        // console.log({
        //     videoOn,
        //     zoomParticipant,
        //     videoElement,
        //     mediaStream,
        // });

        // 如果之前已经attach了视频，但bVideoOn变为false，需要先detach
        if (!videoOn && currentAttachedUserId.current && videoElement && mediaStream) {
            console.log('detach video');
            mediaStream.detachVideo(currentAttachedUserId.current, videoElement);
            currentAttachedUserId.current = null;
            setIsVideoOn(false);
            return;
        }

        // 如果bVideoOn为true，且满足条件，则attach视频
        if (videoOn && mediaStream && videoElement && userId) {
            // 如果之前已经attach了其他用户的视频，先detach
            if (currentAttachedUserId.current && currentAttachedUserId.current !== userId) {
                mediaStream.detachVideo(currentAttachedUserId.current, videoElement);
            }
            console.log(`attach video: ${userId}`);
            mediaStream.attachVideo(userId, VideoQuality.Video_720P, videoElement);
            currentAttachedUserId.current = userId;
            setIsVideoOn(true);
        }
    }, [zoomParticipant?.userId, zoomParticipant?.bVideoOn, mediaStreamRef, zoomParticipant]);

    return (
        <div className={s.wrap}>
            <video-player-container
                className={s.videoContainerSmall}
                style={{
                    width: width ? `${width}px` : '160px',
                    height: height ? `${height}px` : '90px',
                }}
            >
                <video-player
                    className={s.videoPlayerSmall}
                    style={{
                        width: width ? `${width}px` : '160px',
                        height: height ? `${height}px` : '90px',
                    }}
                    ref={(el) => {
                        videoRef.current = el;
                    }}
                />
            </video-player-container>
            {!isVideoOn && (
                <div
                    className={s.placeHolder}
                    style={{
                        width: width ? `${width}px` : '160px',
                        height: height ? `${height}px` : '90px',
                    }}
                >
                    <img src={Logo} alt="logo" width={30} height={30} className={s.logo} />
                    <div className={s.holderName}>{zoomParticipant?.displayName}</div>
                </div>
            )}
        </div>
    );
};

export default ZoomPIPView;
